export var AssetsList = [
    "AAVE",
    "UNI",
    "WAVAX",
    "sAVAX",
    "WETH",
    "USDC",
    "USDC.e",
    "WBTC",
    "stETH",
    "rETH",
    "wstETH",
    "yvUSDC",
    "RBN",
    "veRBN",
    "LDO",
    "SOL",
    "APE",
    "WBNB",
    // Treasury
    "PERP",
    "BAL",
    "BADGER",
    "SPELL",
    "SAMB",
];
export var WalletsList = [
    "Metamask",
    "WalletConnect",
    "WalletLink",
    "Phantom",
    "Solflare",
];
export var GovernanceStakeTransactions = [
    "governanceStake",
    "governanceIncreaseAmount",
    "governanceIncreaseDuration",
];
export var GovernanceApproveUnstakeTransactions = [
    "governanceApproval",
    "governanceUnstake",
];
//# sourceMappingURL=types.js.map